import React, { useState } from "react";
import Overview from "./campaignDetail/Overview";
import Donations from "./campaignDetail/Donations";
import Subscriptions from "./campaignDetail/Subscriptions";
import Fundraisers from "./campaignDetail/fundraiser/Fundraisers";
import { Button } from "antd";
import { useParams } from "react-router-dom";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"; 
import { useSelector } from "react-redux";


const CampaignDetail = () => {
  const isMenuOpen = useSelector((state) => state.sidebar.isMenuOpen);
  console.log(isMenuOpen)
  const [activeSection, setActiveSection] = useState("Overview");
  const { id } = useParams();

  const renderSection = () => {
    switch (activeSection) {
      case "Overview":
        return <Overview />;
      case "Donations":
        return <Donations />;
      case "Subscriptions":
        return <Subscriptions />;
      case "Fundraisers":
        return <Fundraisers campaignId={id} />;
      default:
        return <Overview />;
    }
  };

  const renderStatusIcon = (status) => {
    return status ? (
      <CheckCircleOutlined style={{ color: "green", marginLeft: "8px" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "red", marginLeft: "8px" }} />
    );
  };

  return (
    <div
    className={`bg-[#41c0e0] sm:p-4 w-auto pt-10 min-h-screen ${
      isMenuOpen ? "ml-64 " : "ml-0"
    } transition-all duration-300`}
  >
      <div className="bg-white shadow-md rounded-lg p-10 min-h-[50vh] min-w-[60vw] ml-28">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-semibold text-gray-700">
            Campaign Details
          </h1>
          <Button className="bg-blue-500 text-white hover:bg-blue-600">
            Edit
          </Button>
        </div>

        <div className="flex gap-4 border-b border-gray-200 pb-2">
          {["Overview", "Donations", "Subscriptions", "Fundraisers"].map(
            (section) => (
              <div
                key={section}
                className={`cursor-pointer px-4 py-2 rounded-lg text-sm font-medium ${
                  activeSection === section
                    ? "bg-blue-500 text-white"
                    : "text-gray-600 hover:bg-blue-100"
                }`}
                onClick={() => setActiveSection(section)}
              >
                {section}
              </div>
            )
          )}
        </div>

        <div className="mt-6 bg-gray-50 p-6 rounded-lg shadow-inner">
          {renderSection()}
        </div>
      </div>
    </div>
  );
};

export default CampaignDetail;
